<template>
  <footer
    id="contact"
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
    style="background-color:#131C21;"
  >    
    <div class="container">
      <div class="row">
        <!--
      <div class="col-md-3 col-sm-12 mb-3 text-center city" >
         <img src="img/transplus.png" height="42px" id="tplogo" alt="" style="filter: grayscale(100%) brightness(1200%); ">  
         
         <br>
         
        <span style="padding:5px"> 
           <a href="https://www.facebook.com/TransPlus-106609531767963" target="_blank"><i class="fab fa-facebook-square fa-2x"></i></a>
        </span>
        <span>
          <a href="https://ca.linkedin.com/company/transplus" target="_blank"><i class="fab fa-linkedin fa-2x"></i></a>
         </span>

      </div>
        -->
      
        <div class="copyright col-md-12">
          <img
            id="tplogo"
            src="img/transplus.png"
            height="42px"
            alt=""
            style="filter: grayscale(100%) brightness(1200%); "
          >  
         
          <br>
         
          <!--
        <span style="padding:5px"> 
           <a href="https://www.facebook.com/TransPlus-106609531767963" target="_blank"><i class="fab fa-facebook-square fa-2x"></i></a>
        </span>
        <span>
          <a href="https://ca.linkedin.com/company/transplus" target="_blank"><i class="fab fa-linkedin fa-2x"></i></a>
         </span>
            
         <br>
        -->
        
          &copy; {{ year }} Transplus  Inc, All rights reserved. <br>
          <a
            target="_blank"
            href="https://docs.google.com/document/d/e/2PACX-1vSRXshaTYwWsiY7zCOSys7Qz0MvYRAIGN3X8kP2OdPR7xj1SMMeIMeTIA7Z_Sjt2w/pub"
            v-html="$t('index.privacy')"
          >Privacy Policy</a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {    
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
<style>
#map-canvas{
  top:-24px;
  padding-bottom: 24px; 
}

.copyright {
  text-align: center;
}
.hoverwhite {
  color: green;
}
.hoverwhite:hover{
  color: white;
}
.phonenumber{
  padding-left: -100px;
}
.gap {
  margin-bottom: 20px
}
</style>
